import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { CircularProgress } from "../../UI/Progress";

export const SnapChatCallBack = (): React.JSX.Element => {
  const location = useLocation();
  
    useEffect(() => {
      const QueryParams = new URLSearchParams(location.search);
      const AuthCode: any = QueryParams.get("code");
      const channel = new BroadcastChannel("snapchat-auth-channel");
      channel.postMessage({ code: AuthCode });
      channel.close();
      window.close(); // Close the child window
    }, []);
    return <CircularProgress />;
};